import React from "react";
import { PhoneCall, X } from "lucide-react";
import { theme } from "../../assets/theme/theme";
import Whatsappicon from "../../assets/icons/WhatsApp.svg";

const HelpSupportModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const phoneNumber = "+918247895454";
  const whatsappUrl = `https://wa.me/918247895454?text=${encodeURIComponent(
    "Hello Support Team, I need help regarding my delivery trip."
  )}`;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-xs animate-fadeIn">
      <div
        className="w-full max-w-sm bg-white rounded-t-3xl sm:rounded-3xl p-5 space-y-4 shadow-2xl border flex flex-col animate-slideUp"
        style={{ borderColor: theme.colors.grey002 || "#E5E7EB" }}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between pb-3 border-b"
          style={{ borderColor: theme.colors.grey005 || "#F3F4F6" }}
        >
          <h3
            className="text-lg font-bold"
            style={{
              fontFamily: "BarlowCondensed-Bold",
              color: theme.colors.bitumen || "#111827",
            }}
          >
            Help and Support Desk
          </h3>

          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 rounded-full flex items-center justify-center bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer"
          >
            <X className="w-4 h-4 text-gray-700" />
          </button>
        </div>

        {/* 2 Support Action Tiles */}
        <div className="space-y-2.5">
          {/* 1. WhatsApp Chat */}
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            className="w-full p-3.5 rounded-2xl border flex items-center justify-between transition-all duration-150 active:scale-[0.99] cursor-pointer"
            style={{
              backgroundColor: "#F0FDF4",
              borderColor: "#BBF7D0",
            }}
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-emerald-500 shadow-xs shrink-0">
                <img
                  src={Whatsappicon}
                  alt="WhatsApp"
                  className="w-5 h-5 object-contain"
                />
              </div>
              <div className="text-left">
                <p
                  className="text-xs font-bold leading-tight text-emerald-950"
                  style={{ fontFamily: "DMSans-SemiBold" }}
                >
                  WhatsApp Support
                </p>
                <p className="text-[11px] text-emerald-700 mt-0.5 font-medium">
                  Chat with team on WhatsApp
                </p>
              </div>
            </div>
          </a>

          {/* 2. Direct Call */}
          <a
            href={`tel:${phoneNumber}`}
            onClick={onClose}
            className="w-full p-3.5 rounded-2xl border flex items-center justify-between transition-all duration-150 active:scale-[0.99] cursor-pointer"
            style={{
              backgroundColor: theme.colors.grey001 || "#F9FAFB",
              borderColor: theme.colors.grey005 || "#E5E7EB",
            }}
          >
            <div className="flex items-center gap-3">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center shadow-xs shrink-0"
                style={{
                  backgroundColor: theme.colors.bitumen || "#111827",
                  color: theme.colors.pureWhite || "#FFFFFF",
                }}
              >
                <PhoneCall className="w-5 h-5" />
              </div>
              <div className="text-left">
                <p
                  className="text-xs font-bold leading-tight"
                  style={{
                    fontFamily: "DMSans-SemiBold",
                    color: theme.colors.bitumen || "#111827",
                  }}
                >
                  Direct Call
                </p>
                <p
                  className="text-[11px] mt-0.5 font-medium"
                  style={{
                    fontFamily: "DMMono-Regular",
                    color: theme.colors.concrete || "#6B7280",
                  }}
                >
                  Tap here to directly call our support team.
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HelpSupportModal;